import TabContract from './TabContract';

export default TabContract;
